<template>
  <div class="dropdown admin-profile">
    <div
      class="d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor dropdown-toggle"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <div class="flex-shrink-0">
        <span class="rounded-circle wh-40 d-flex align-items-center justify-content-center bg-primary text-white fs-20">
          <i class="material-symbols-outlined">person</i>
        </span>
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-none d-xxl-block">
            <div class="d-flex align-content-center">
              <h3>{{ firstNameOnly }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-menu border-0 dropdown-menu-end">
      <!-- Mobile greeting -->
       <span class="mobile-greeting d-md-none  fw-semibold mb-1" style="background:none !important;">
                    Ciao, <span class="text-primary">{{ firstNameOnly }}!</span>
       </span>

      <ul class="admin-link ps-0 mb-0 list-unstyled">
        <!-- Settings - Hidden temporarily -->
        <!-- <li>
          <RouterLink
            class="dropdown-item d-flex align-items-center text-body"
            to="/social/settings"
          >
            <i class="material-symbols-outlined">settings </i>
            <span class="ms-2">Settings</span>
          </RouterLink>
        </li> -->

        <!-- Support - Hidden temporarily -->
        <!-- <li>
          <RouterLink
            class="dropdown-item d-flex align-items-center text-body"
            to="/help-desk/tickets"
          >
            <i class="material-symbols-outlined">support</i>
            <span class="ms-2">Support</span>
          </RouterLink>
        </li> -->

        <li>
          <a
            class="dropdown-item d-flex align-items-center text-body"
            href="#"
            @click.prevent="handleLogout"
          >
            <i class="material-symbols-outlined">logout</i>
            <span class="ms-2">Logout</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { authStore } from '@/stores/auth';
import { useRouter } from 'vue-router';

const router = useRouter();

const user = computed(() => authStore.user.value);

const firstNameOnly = computed(() => {
  if (user.value && user.value.name) {
    return user.value.name.split(' ')[0];
  }
  return 'Guest';
});

const handleLogout = async () => {
  await authStore.logout();
  // Redirect to login page or home page after logout
  router.push('/');
};
</script>

<style scoped>
.mobile-greeting {
  background-color: #f8f9fa;
}

.mobile-greeting h6 {
  font-weight: 600;
}

.border-bottom {
  border-color: #e9ecef !important;
}
</style>